
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.toSitePalette

@Composable
fun CommonDivider(width: Int = 0, height: Int = 0, color: Color.Rgb,) {
    val sitePalette = ColorMode.current.toSitePalette()
    val tagColor = sitePalette.commonSecondaryButtonColor.rgb
    FieldTitleTextNormalSimple(
        text = " | ",
//        color = sitePalette.commonSecondaryButtonColor.rgb,
        color = tagColor
    )
}
